module.exports = __webpack_public_path__ + "img/bg2.00ca74d6.png";